module.exports = __webpack_public_path__ + "img/DE05744.02bb8c27.png";